/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState } from 'react';
import {
  Container, Row, Col,
} from 'react-bootstrap';
import logo from 'assets/img/logo-white-full.png';
import classNames from 'classnames';
import LinkInvitationStep2 from 'components/LinkInvitation/Step2';
import LinkInvitationStep3 from 'components/LinkInvitation/Step3';
import LinkInvitationStep4 from 'components/LinkInvitation/Step4';
import LinkInvitationStep5 from 'components/LinkInvitation/Step5';
import LinkInvitationStep0 from 'components/LinkInvitation/Step0';
import { LinkExternalSteps } from 'constants/utils';
import { Document, Invitation, InvitationData } from 'types/Invitation';
import LinkInvitationStepDefault from 'components/LinkInvitation/StepDefault';
import LinkInvitationStep6 from 'components/LinkInvitation/Step6';

type LinkInvitationViewProps = {
  invitationData: InvitationData | null;
  step: LinkExternalSteps;
  onNext: ( values: any ) => void;
  handleSubmitNda: ( ) => void;
  onPrevious: () => void;
  onCloseInvitationAccess: () => void;
  documents: Document[]
  pdfNdaUrl?:string
};

function LinkInvitationView( {
  step, onNext, onPrevious, invitationData, documents, pdfNdaUrl,
  onCloseInvitationAccess, handleSubmitNda,
}:LinkInvitationViewProps ) {
  return (
    <Container fluid className="p-lg-0 body-onboarding-container">
      <Row className="vh-100 g-lg-0">
        <Col lg="auto" className="d-none d-lg-flex bg-blue">
          <img src={logo} alt="Grupo Impar" height={38} />
          <div className="blue-bg-img" />
          <div className="slider">
            {Object.values( LinkExternalSteps ).map( ( item ) => (
              <div
                key={item}
                className={classNames( 'slider-item', { active: step === item } )}
              />
            ) )}
          </div>
        </Col>
        <Col lg className="bg-image">
          <Row className="h-100 g-lg-0">
            <Col lg={{ span: 10, offset: 1 }} xl={{ span: 7, offset: 1 }} className="my-auto">
              <div className="card--light">
                {step === LinkExternalSteps.default
                && (
                  <LinkInvitationStepDefault />
                )}
                {step === LinkExternalSteps.code
                && (
                  <LinkInvitationStep0
                    onNext={onNext}
                    onPrevious={onPrevious}
                  />
                )}
                {step === LinkExternalSteps.information
                && (
                  <LinkInvitationStep2
                    onNext={onNext}
                  />
                )}
                {step === LinkExternalSteps.warning
                && (
                  <LinkInvitationStep3
                    onNext={onNext}
                    invitationData={invitationData}
                    handleSubmitNda={handleSubmitNda}
                  />
                )}
                {step === LinkExternalSteps.signature
                && (
                  <LinkInvitationStep4
                    onNext={onNext}
                    invitationData={invitationData}
                    pdfNdaUrl={pdfNdaUrl}
                  />
                )}
                {step === LinkExternalSteps.summary
                && (
                  <LinkInvitationStep5
                    documents={documents}
                    uuid={invitationData?.invitacionUid || ''}
                    onCloseInvitationAccess={onCloseInvitationAccess}
                  />
                )}
                {step === LinkExternalSteps.finish
                && (
                  <LinkInvitationStep6 />
                )}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default LinkInvitationView;
